/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_see_more_results_search20 = /** @type {(inputs: { total: NonNullable<unknown> }) => string} */ (i) => {
	return `See ${i.total} more results`
};

const fr_see_more_results_search20 = /** @type {(inputs: { total: NonNullable<unknown> }) => string} */ (i) => {
	return `Afficher ${i.total} résultats supplémentaires`
};

const de_see_more_results_search20 = /** @type {(inputs: { total: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.total} weitere Ergebnisse anzeigen`
};

const es_see_more_results_search20 = /** @type {(inputs: { total: NonNullable<unknown> }) => string} */ (i) => {
	return `Ver ${i.total} más resultados`
};

const it_see_more_results_search20 = /** @type {(inputs: { total: NonNullable<unknown> }) => string} */ (i) => {
	return `Visualizza ${i.total} altri risultati`
};

const ar_see_more_results_search20 = /** @type {(inputs: { total: NonNullable<unknown> }) => string} */ (i) => {
	return `شاهد ${i.total} المزيد من النتائج`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ total: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const see_more_results_search20 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.see_more_results_search20(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("see_more_results_search20", locale)
	if (locale === "en") return en_see_more_results_search20(inputs)
	if (locale === "fr") return fr_see_more_results_search20(inputs)
	if (locale === "de") return de_see_more_results_search20(inputs)
	if (locale === "es") return es_see_more_results_search20(inputs)
	if (locale === "it") return it_see_more_results_search20(inputs)
	return ar_see_more_results_search20(inputs)
};
export { see_more_results_search20 as "SEE_MORE_RESULTS_SEARCH" }